import Head from "../components/Head";
import Login from "../components/Login";

function MainPage() {
  
    return (
      <>
        <Head />
        <Login />
      </>
    );
  }
  
  export default MainPage;